module.exports = __webpack_public_path__ + "static/header-58036a188ebee7b0e28b31b50b895477.png";